import { useState, useEffect, createContext, useContext } from 'react';
import useMyAppStore from '../stores/myAppStore';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const { currentUser, setCurrentUser, clearCurrentUser } = useMyAppStore();

  useEffect(() => {
    // Vérifier si l'utilisateur est déjà connecté
    const checkAuth = async () => {
      try {
        const token = localStorage.getItem('token');
        if (token && currentUser) {
          // L'utilisateur est déjà connecté via le store
          // console.log('✅ Utilisateur déjà connecté:', currentUser);
        } else if (token && !currentUser) {
          // Token existe mais pas d'utilisateur dans le store
          // TODO: Récupérer les données utilisateur depuis le backend
          console.log('⚠️ Token trouvé mais pas d\'utilisateur dans le store');
        }
      } catch (error) {
        console.error('Erreur lors de la vérification de l\'authentification:', error);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [currentUser]);

  const login = async (userData) => {
    try {
      // Si on a des données utilisateur, les utiliser directement
      if (userData && userData.id) {
        localStorage.setItem('token', 'user-token');
        return userData;
      }
      
      // Sinon, vérifier si currentUser existe dans le store
      if (currentUser) {
        localStorage.setItem('token', 'user-token');
        return currentUser;
      } else {
        throw new Error('Aucun utilisateur trouvé');
      }
    } catch (error) {
      throw new Error('Échec de la connexion');
    }
  };

  const register = async (userData) => {
    try {
      // TODO: Implémenter l'appel API réel
      // Créer un nouvel utilisateur et le définir dans le store
      const newUser = {
        id: Date.now(), // ID temporaire
        ...userData
      };
      
      setCurrentUser(newUser);
      localStorage.setItem('token', 'user-token');
      return newUser;
    } catch (error) {
      throw new Error('Échec de l\'inscription');
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    clearCurrentUser();
  };

  const value = {
    user: currentUser,
    loading,
    login,
    register,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth doit être utilisé à l\'intérieur d\'un AuthProvider');
  }
  return context;
};

export default useAuth; 